import { FunctionComponent } from 'react';
import CheckboxFilterGroup, { CheckboxDataSource, CheckboxDsType } from './CheckboxFilterGroup';
import FilterGroupProps from './FilterGroupProps';
import ReferenceFilterGroup, { ReferenceDsType } from './ReferenceFilterGroup';

export type FilterGroupDsType = CheckboxDsType | ReferenceDsType;

export type FilterGroupDataSource = FilterGroupDsType['dataSource'];
export type FilterGroupType = FilterGroupDsType['type'];

export type DsTypeMapping = {
  [K in FilterGroupDsType['type']]: Extract<FilterGroupDsType, { type: K }>;
};

export type DsTypeProps = {
  [K in keyof DsTypeMapping]: FilterGroupProps<DsTypeMapping[K]>;
};

export type FilterGroupComponents = {
  [K in keyof DsTypeMapping]: FunctionComponent<DsTypeProps[K]>;
};

export const filterGroups: FilterGroupComponents = {
  checkbox: CheckboxFilterGroup,
  reference: ReferenceFilterGroup,
};
